import React from "react";
import { useAuth } from "../../contexts/authContext";
import { auth } from "../../firebase/config";
import { signOut } from "firebase/auth";
import { Navigate } from "react-router-dom";
import Navbar from "../../components/Navbar";

function Account() {
  const { userLoggedIn } = useAuth();

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (err) {
      console.error("Error signing out:", err);
    }
  };

  if (!userLoggedIn) {
    return <Navigate to="/" replace />;
  }

  return (
    <div>
      <Navbar />

      <div className="flex justify-center mt-20 px-4">
        <div className="w-full max-w-md rounded-lg border border-gray-200 p-6 shadow-sm">
          <h1 className="text-2xl font-semibold text-center mb-6">
            Account
          </h1>

          <div className="mb-6">
            <p className="text-sm font-medium text-gray-600">
              Email
            </p>
            <p className="text-gray-900">
              {userLoggedIn.email}
            </p>
          </div>

          <button
            onClick={handleLogout}
            className="w-full rounded-md bg-red-600 px-4 py-2 text-white font-medium hover:bg-red-700 transition"
          >
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
}

export default Account;